import { render } from "./noticeComponent.vue?vue&type=template&id=181b51ff&scoped=true"
import script from "./noticeComponent.vue?vue&type=script&lang=js"
export * from "./noticeComponent.vue?vue&type=script&lang=js"

import "./noticeComponent.vue?vue&type=style&index=0&id=181b51ff&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181b51ff"]])

export default __exports__